import { StatusIndicator } from '@routable/gross-ds';
import React from 'react';
import { TableCellTextWithSubtext } from 'complexComponents/Table/components';
const StatusWithText = ({ children, status, className, secondaryText }) => (React.createElement(TableCellTextWithSubtext, { subtext: secondaryText, text: React.createElement(StatusIndicator, { status: status }, children), textClassName: className }));
export default StatusWithText;
